// @flow
import { ErightsActionTypes } from './constants';

// import { APICore } from '../../helpers/api/apiCore';

// const api = new APICore();

const INIT_STATE = {
    eright: {},
    listaErights: [],
    loading: false,
    loadingList: false,
    error: false,
    errorList: false,
    formSubmited: false
};

type ErightsAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { eright?: {} | null, listaErights?: [] | null, loading?: boolean, +value ?: boolean };

const Erights = (state: State = INIT_STATE, action: ErightsAction): any => {
    // console.log(action);
    switch (action.type) {
        case ErightsActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case ErightsActionTypes.GET_ERIGHT: {
                    return {
                        ...state,
                        eright: action.payload.data,
                        error: false,
                        loading: false,
                        formSubmited: false
                    };
                }
                case ErightsActionTypes.LIST_ERIGHTS: {
                    return {
                        ...state,
                        listaErights: action.payload.data,
                        errorList: false,
                        loadingList: false,
                        formSubmited: false
                    };
                }
                case ErightsActionTypes.ADD_ERIGHT: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case ErightsActionTypes.UPDATE_ERIGHT: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        // usuario: action.payload.data,
                        formSubmited: true
                    };
                }
                case ErightsActionTypes.DELETE_ERIGHT: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case ErightsActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case ErightsActionTypes.GET_ERIGHT: {
                    return {
                        ...state,
                        error: action.payload.error,
                        eright: {},
                        loading: false,
                        formSubmited: false
                    };
                }
                case ErightsActionTypes.LIST_ERIGHTS: {
                    return {
                        ...state,
                        errorList: true,
                        listaErights: [],
                        loadingList: false,
                        formSubmited: false
                    };
                }
                case ErightsActionTypes.ADD_ERIGHT: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case ErightsActionTypes.UPDATE_ERIGHT: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case ErightsActionTypes.DELETE_ERIGHT: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case ErightsActionTypes.GET_ERIGHT:
            return { ...state, error: false, loading: true };
        case ErightsActionTypes.LIST_ERIGHTS:
            return { ...state, errorList: false, loadingList: true };
        case ErightsActionTypes.ADD_ERIGHT:
            return { ...state, error: false, loading: false };
        case ErightsActionTypes.UPDATE_ERIGHT:
            return { ...state, error: false, loading: false };
        case ErightsActionTypes.DELETE_ERIGHT:
            return { ...state, error: false, loading: false };
        case ErightsActionTypes.RESET:
            return {
                ...state,
                loading: false,
                error: false,
                loadingList: false,
                errorList: false,
                eright: {},
                listaErights: [],
                formSubmited: false
            };
        default:
            return { ...state };
    }
};

export default Erights;
